import { Environment } from '~/types/app'

export const setDebugEnvVars = () => {
  if (window?.['ENV']?.env !== Environment.PROD) {
    window['ENV']['flags'] = {
      toggleDebugMenu: () => {
        // note: we can't use the local storage hook here because it causes SSR issues
        localStorage.setItem('portal.showDebugMenu', JSON.stringify(!JSON.parse(localStorage.getItem('portal.showDebugMenu') || 'false')))
        location.reload()
      }
    }
  }
}